import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import Layout from '../../../layout/Layout';
import PermissionsGate from '../../../components/PermissionsGate/PermissionsGate';
import { permissions } from '../../../common/permissionGroup';
import UserSkeleton from './UserSkeleton';
import getUserDetails from '../../../thunks/users/getUserDetails';
import AccessDenied from '../../../components/AccessDenied/AccessDenied';
import routes from '../../../router/routes';
import UserCard from './components/UserCard';
import TabNavigation from '../../../components/TabNavigation/TabNavigation';
import { profileNavigationTabsType, userProfileNavigationTabs } from '../../../common/profileNavigationTabs';
import { setApplicationState } from '../../../actions/application/application';
import UserDetailsLog from './components/UserDetailsLog';

const containerClassName = 'flex flex-row min-w-full';
const rightSideClassName = 'flex flex-col w-full mt-[10px] ml-[50px]';
const tabsItemClassName = 'mb-[26px]';

const UserDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    application: { userProfileActiveTab },
    getUserDetails: {
      loading, user, user: { name, last_name: lastName } = {}
    }
  } = useSelector((state) => ({
    getUserDetails: state?.getUserDetails,
    application: state.application
  }), shallowEqual);

  useEffect(() => {
    dispatch(getUserDetails(id));
  }, [id]);

  const breadcrumbs = {
    pageTitle: 'Account Overview',
    history: [
      {
        title: 'Home',
        onClick: () => navigate('/')
      },
      {
        title: 'User management',
      },
      {
        title: 'Users',
        onClick: () => navigate(routes.USERS)
      },
      {
        title: `${name} ${lastName || ''}`,
      }
    ]
  };

  return (
    <Layout breadcrumbs={breadcrumbs}>
      {loading ? <UserSkeleton /> : (
        <PermissionsGate can={permissions.USERS_READ} errorComponent={<AccessDenied />}>
          <div className={containerClassName}>
            <div className="flex">
              <UserCard user={user} />
            </div>
            <div className={rightSideClassName}>
              <TabNavigation
                tabs={userProfileNavigationTabs}
                activeType={userProfileActiveTab}
                onClick={(type) => dispatch(setApplicationState({ userProfileActiveTab: type }))}
                itemStyle={tabsItemClassName}
              />
              <div>
                {userProfileActiveTab === profileNavigationTabsType.EVENTS_LOGS && <UserDetailsLog userId={id} />}
              </div>
            </div>
          </div>
        </PermissionsGate>
      )}
    </Layout>
  );
};

UserDetails.propTypes = {};

UserDetails.defaultProps = {};

export default UserDetails;
